import { ResourceCardWrapper } from 'app/components/Resources/ResourceCard/styled';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import {
  slideToLeftAndRightCardAnimation,
  slideToLeftAndRightExtraCardAnimation,
} from 'styles/animations';

export const ResourcesStepsOneSpotlightWrapper = styled(motion.div)`
  width: fit-content;
  position: relative;
  min-width: 288px;
  min-height: 455px;

  & ${ResourceCardWrapper} {
    min-width: 288px;
    min-height: 455px;

    justify-content: center;
  }

  & [data-id='people-matched-detail-pills'] {
    display: none;
  }
`;

interface ResourcesStepsOneSpotlightBackgroundCardProps {
  triggerNext?: boolean;
}

export const ResourcesStepsOneSpotlightBackgroundCard = styled(
  motion.div
)<ResourcesStepsOneSpotlightBackgroundCardProps>`
  position: absolute;
  top: 0;
  left: 0;
`;

export const ResourcesStepsOneSpotlightBackgroundCardOne = styled(
  ResourcesStepsOneSpotlightBackgroundCard
)`
  ${({ triggerNext }) => (triggerNext ? slideToLeftAndRightExtraCardAnimation : '')}
`;

export const ResourcesStepsOneSpotlightBackgroundCardTwo = styled(
  ResourcesStepsOneSpotlightBackgroundCard
)`
  ${({ triggerNext }) => (triggerNext ? slideToLeftAndRightCardAnimation : '')}
`;
